<template>
  <v-container>
    <v-card class="pa-3">
      <BackHeader class="cabecera" :title="empresa.nombre" :onBack="onBack"></BackHeader>

      <!-- La cabecera ya trae su propio aire abajo: sin esto el contenido
           queda demasiado separado del título. -->
      <v-row class="mt-n3">
        <v-col cols="12" md="5">
          <DarkCard title="Información" icon="mdi-domain">
            <v-row>
              <v-col>
                <h5 class="mb-0 font-weight-bold">Nombre:</h5>
                <p class="mb-0 font-italic">{{ empresa.nombre }}</p>
              </v-col>
              <v-col>
                <h5 class="mb-0 font-weight-bold">Rut:</h5>
                <p class="mb-0 font-italic">{{ empresa.rut }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h5 class="mb-0 font-weight-bold">Cantidad de sucursales:</h5>
                <p class="mb-0 font-italic">{{ empresa.sucursales.length }}</p>
              </v-col>
              <v-col>
                <h5 class="mb-0 font-weight-bold">Nota:</h5>
                <div class="d-flex align-center">
                  <v-rating
                    color="primary"
                    background-color="grey darken-1"
                    fullIcon="mdi-star"
                    half-icon="mdi-star-half-full"
                    half-increments
                    emptyIcon="mdi-star-outline"
                    :value="empresa.nota.promedio"
                    readonly
                    dense
                  ></v-rating>
                  <span class="ml-2 subtitle-1 font-italic text-no-wrap">
                    {{ Math.round(empresa.nota.promedio * 10) / 10 }} ({{ empresa.nota.total }})
                  </span>
                </div>
              </v-col>
            </v-row>
          </DarkCard>
          <!-- Acciones sobre la empresa, bajo su tarjeta. -->
          <v-row v-if="$slots['acciones-empresa']" no-gutters justify="end" class="mb-4">
            <slot name="acciones-empresa"></slot>
          </v-row>

          <Title text="Sucursales" icon="mdi-map-marker"></Title>
          <DarkCard v-for="item in empresa.sucursales" :key="item.id">
            <div class="d-flex align-center">
              <span class="flex-grow-1">
                {{ item.direccion }}, {{ item.region.name }}, {{ item.pais.name }}
              </span>
              <!-- Acciones sobre cada sucursal. -->
              <slot name="acciones-sucursal" :sucursal="item"></slot>
            </div>
          </DarkCard>

          <div v-if="empresa.sucursales.length == 0">
            <v-row class="ma-2" align="center" justify="center">
              <notFound width="200" height="200"></notFound>
            </v-row>
            <v-row class="ma-2" align="center" justify="center">No hay sucursales</v-row>
          </div>
        </v-col>

        <v-col cols="12" md="7">
          <Title text="Comentarios" icon="mdi-comment-text-outline"></Title>

          <!-- Vienen del más reciente al más antiguo. El alumno que lo
               escribió solo le llega a un administrador. -->
          <DarkCard v-for="(item, indice) in empresa.comentarios" :key="indice">
            <template v-if="item.alumno">
              <div class="d-flex align-center">
                <span class="font-weight-bold">{{ item.alumno }}{{ sigla(item.tipo) }}:</span>
                <v-spacer></v-spacer>
                <span class="caption text--disabled">{{ fecha(item.fecha) }}</span>
              </div>
              <div class="pl-4 mt-1 text--secondary">{{ item.comentario }}</div>
            </template>
            <div v-else class="d-flex align-start">
              <span class="flex-grow-1 text--secondary">{{ item.comentario }}</span>
              <span class="ml-4 caption text--disabled text-no-wrap">{{ fecha(item.fecha) }}</span>
            </div>
          </DarkCard>

          <DarkCard v-if="empresa.comentarios.length == 0">
            Aún no se ha realizado ningún comentario sobre esta empresa
          </DarkCard>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import NotFound from "@/components/icons/notFound.vue";
import DarkCard from "@/components/content/DarkCard.vue";
import BackHeader from "@/components/content/BackHeader";
import Title from "@/components/content/Title.vue";

// La ficha de una empresa: información, sucursales y comentarios. La usan la
// vista del alumno y la del administrador, que le agrega sus acciones por los
// slots `acciones-empresa` y `acciones-sucursal`.
export default {
  components: { DarkCard, BackHeader, Title, NotFound },
  props: {
    // El cuerpo de /api/empresas/<id>/.
    empresa: { type: Object, required: true },
    onBack: { type: Function, required: true },
  },
  methods: {
    // Práctica Industrial -> " (PI)", Práctica Profesional -> " (PP)".
    sigla(tipo) {
      return tipo ? ` (P${tipo[0].toUpperCase()})` : "";
    },

    // "2026-09-15" -> "15/09/26"
    fecha(iso) {
      if (!iso) {
        return "";
      }
      const [anio, mes, dia] = iso.split("-");
      return `${dia}/${mes}/${anio.slice(2)}`;
    },
  },
};
</script>

<style scoped>
/* BackHeader reserva el alto del subtítulo aunque no haya ninguno. */
.cabecera >>> .v-card__subtitle {
  display: none;
}
</style>
